<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/vDGdkf/tc-custom/9781495634208.jpg?1714418547249" alt="This image is the cover for the book Potions Inc. #3, Potions Inc."/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Potions Inc. #3, Potions Inc.
      </h1>
      <p class="bookDescription body article font2">
        <p>Geneva takes Ran and the twins to the one person on Earth who possesses the other half of the Fordstone, and boy does he have a story to tell. From him they learn about the Fordstone’s origins and the powerful wizard, Kanavin Goras, whose plan nearly destroyed Earth and Primaterra both. Naturally Goras’ lust for power wasn’t quenched all those years ago.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Eric Burnham, Stelladia
      </h2>
      
      <p class="authorDescription body article">Erik Burnham is a writer and cartoonist. He's worked on both creator owned and licensed comics and still can't believe how lucky he is. Erik works with Mad Cave Studios, Dynamite, IDW, Insight Editions, Marvel, and Panini on properties such as Ghostbusters, Teenage Mutant Ninja Turtles, Back to the Future, Galaxy Quest, Scarlet Spider, New Warriors, Red Sonja, KISS, and Potions Inc. -- with more on the way. (Which is good news, because he loves his work.)</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Mad Cave Studios
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3b56a144